<template>
  <transition name="sticky-header-slide">
    <div class="header header--sticky" v-show="active">
      <div class="header__inner">
        <div class="header__container">
          <div class="sticky-header__left">
            <a v-if="logoLink" :href="logoLink">
              <logo class="header__logo" />
            </a>
          </div>
          <div class="sticky-header__right">
            <header-content :has-signup-link="hasSignupLink" :cta="cta" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Logo from "@/component-library/b-logo"
import HeaderContent from "@/features/header/components/header-content.vue"
import getLocale from "@/utils/locale"

export default {
  name: "StickyHeader",
  components: {
    HeaderContent,
    Logo
  },
  props: {
    hasSignupLink: { type: Boolean, default: false },
    active: { type: Boolean, default: false },
    cta: {
      type: Object,
      default: null,
      validator: function (value) {
        return typeof value.copy === "string" && typeof value.href === "string"
      }
    },
    hasLogoLink: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    logoLink() {
      if (this.hasLogoLink) {
        return `/${getLocale()}/`
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="scss">
.sticky-header-slide-enter-active,
.sticky-header-slide-leave-active {
  transition: 0.25s ease;
}

.sticky-header-slide-enter,
.sticky-header-slide-leave-to {
  transform: translateY(-100%);

  opacity: 0;
}
</style>
